import PropTypes from 'prop-types';

import { Button, ClearTable as ClearTableIcon, Edit, Refresh as RefreshIcon, WithTooltip } from 'basic-components';

import './EditHeader.scss';

const EditHeader = ({ clearTable, onClose, refreshCall }) => (
  <div className="ng-office-edit-header">
    <div className="ng-office-edit-header__left">
      <div className="ng-office-edit-header__left__icon">
        <Edit
            color="grey-dark"
            height={16}
            width={16}
        />
      </div>
      <div className="ng-office-edit-header__left__label">
        Call Edit
      </div>
    </div>
    <div className="ng-office-edit-header__right">
      <div className="ng-office-edit-header__right__actions">
        <WithTooltip
            data-place="left"
            text="Download latest data."
        >
          <div 
              className="ng-office-edit-header__right__actions__icon"
              onClick={refreshCall}
          >
            <RefreshIcon
                color="blue-bright"
                height={16}
                width={16}
            />
          </div>
        </WithTooltip>
        <WithTooltip
            data-place="left"
            text="Clear table and formula."
        >
          <div 
              className="ng-office-edit-header__right__actions__icon"
              onClick={clearTable}
          >
            <ClearTableIcon
                color="red-dark"
                height={16}
                width={16}
            />
          </div>
        </WithTooltip>
      </div>
      <div className="ng-office-edit-header__right__close">
        <Button 
            onClick={onClose}
            size="small"
            variant="text"
        >
          Close
        </Button>
      </div>
    </div>
  </div>
)

EditHeader.propTypes = {
  clearTable: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  refreshCall: PropTypes.func.isRequired,
}

export default EditHeader;